var map = {
	"./defaults/citizen_science_project_image/slider": 147,
	"./defaults/citizen_science_project_image/slider.png": 147,
	"./defaults/citizen_science_project_image/small": 148,
	"./defaults/citizen_science_project_image/small.png": 148,
	"./defaults/citizen_science_project_image/thumb": 149,
	"./defaults/citizen_science_project_image/thumb.png": 149,
	"./defaults/featured_content_image/slider": 150,
	"./defaults/featured_content_image/slider.png": 150,
	"./defaults/featured_content_image/small": 151,
	"./defaults/featured_content_image/small.png": 151,
	"./defaults/featured_content_image/thumb": 152,
	"./defaults/featured_content_image/thumb.png": 152,
	"./defaults/partner_image/small": 153,
	"./defaults/partner_image/small.png": 153,
	"./defaults/partner_image/thumb": 154,
	"./defaults/partner_image/thumb.png": 154,
	"./defaults/placeholder": 155,
	"./defaults/placeholder.png": 155,
	"./defaults/post_image/small": 156,
	"./defaults/post_image/small.png": 156,
	"./defaults/post_image/thumb": 157,
	"./defaults/post_image/thumb.png": 157,
	"./defaults/questionnaire_image/small": 158,
	"./defaults/questionnaire_image/small.png": 158,
	"./defaults/questionnaire_image/thumb": 159,
	"./defaults/questionnaire_image/thumb.png": 159,
	"./eit-health-logo": 160,
	"./eit-health-logo.png": 160,
	"./image-about": 6,
	"./image-about.jpg": 194,
	"./image-about.png": 6,
	"./pages/home/citizen-science-activities-1": 161,
	"./pages/home/citizen-science-activities-1.png": 161,
	"./pages/home/citizen-science-activities-2": 162,
	"./pages/home/citizen-science-activities-2.png": 162,
	"./pages/home/citizen-science-activities-3": 163,
	"./pages/home/citizen-science-activities-3.png": 163,
	"./pages/home/s4play_game": 164,
	"./pages/home/s4play_game.png": 164,
	"./s4p-logo": 165,
	"./s4p-logo-icon": 166,
	"./s4p-logo-icon-white": 167,
	"./s4p-logo-icon-white.svg": 167,
	"./s4p-logo-icon.svg": 166,
	"./s4p-logo.svg": 165,
	"./welcome-game": 168,
	"./welcome-game.jpg": 168,
	"./welcome-questionnaires": 169,
	"./welcome-questionnaires.jpg": 169,
	"./youth_citizens_science/circles": 7,
	"./youth_citizens_science/circles.png": 7,
	"./youth_citizens_science/circles.svg": 195,
	"./youth_citizens_science/form_diagram_en": 170,
	"./youth_citizens_science/form_diagram_en.png": 170,
	"./youth_citizens_science/form_diagram_es": 171,
	"./youth_citizens_science/form_diagram_es.png": 171,
	"./youth_citizens_science/health_citizen_science_studies_logo": 172,
	"./youth_citizens_science/health_citizen_science_studies_logo.svg": 172,
	"./youth_citizens_science/icon": 173,
	"./youth_citizens_science/icon.svg": 173,
	"./youth_citizens_science/logoSJD_navbar": 174,
	"./youth_citizens_science/logoSJD_navbar.jpeg": 174,
	"./youth_citizens_science/logo_banner/image 001": 175,
	"./youth_citizens_science/logo_banner/image 001.png": 175,
	"./youth_citizens_science/logo_banner/image 002": 176,
	"./youth_citizens_science/logo_banner/image 002.png": 176,
	"./youth_citizens_science/logo_banner/image 003": 177,
	"./youth_citizens_science/logo_banner/image 003.png": 177,
	"./youth_citizens_science/logo_banner/image 004": 178,
	"./youth_citizens_science/logo_banner/image 004.png": 178,
	"./youth_citizens_science/logo_banner/image 005": 179,
	"./youth_citizens_science/logo_banner/image 005.png": 179,
	"./youth_citizens_science/logo_banner/image 006": 180,
	"./youth_citizens_science/logo_banner/image 006.png": 180,
	"./youth_citizens_science/logo_banner/image 018": 181,
	"./youth_citizens_science/logo_banner/image 018.png": 181,
	"./youth_citizens_science/logo_banner/image 019": 182,
	"./youth_citizens_science/logo_banner/image 019.png": 182,
	"./youth_citizens_science/logo_banner/image 020": 183,
	"./youth_citizens_science/logo_banner/image 020.png": 183,
	"./youth_citizens_science/logo_banner/image 021": 184,
	"./youth_citizens_science/logo_banner/image 021.png": 184,
	"./youth_citizens_science/logo_banner/image 022": 185,
	"./youth_citizens_science/logo_banner/image 022.png": 185,
	"./youth_citizens_science/your_project_en": 186,
	"./youth_citizens_science/your_project_en.png": 186,
	"./youth_citizens_science/your_project_es": 187,
	"./youth_citizens_science/your_project_es.png": 187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;